import DataGrid, { Column, Scrolling } from 'devextreme-react/data-grid';
import { CardAnalytics } from '../../../components/library/card-analytics/CardAnalytics';
import Button from 'devextreme-react/button';
import { useAppDispatch, useAppSelector } from '../../../contexts/hooks';
import { EReportId } from '../../../types/types.dashboard';
import { useApiDashBoard } from '../../../api/api.dashboards';
import { useState } from 'react';
import { FilteredOrders } from '../../../types/types.orders';
import { setFilteresToOrders } from '../../../contexts/slices/orders';
import { ConvertLocalDate } from '../../../utils/functions';
import { useScreenSize } from '../../../utils/media-query';
import { useNavigate } from 'react-router-dom';

export const BoardWorkList = () => {
  const { getData } = useApiDashBoard();
  const dispatch = useAppDispatch();
  const [dataLoading, setDataLoading] = useState(false);
  const { isXSmall, isSmall } = useScreenSize();
  const navigate = useNavigate();
  const dashboard = useAppSelector((x) => x.dashboards.dashboards.find((x) => x.Db_Id === EReportId.AreasValidation));
  if (!dashboard) {
    return <CardAnalytics title='Órdenes por área' contentClass='sales' />;
  }

  const handleRefreshClick = () => {
    getData(EReportId.AreasValidation);
  };
  const handleViewClick = (data: any) => {
    const today = ConvertLocalDate(new Date());
    const filters: FilteredOrders = {
      Areas: [data.Aa_Id],
      Fechas: [today, today],
      Servicios: [],
      Estudios: [],
      Estados: [],
      Redirect: true,
    };

    setDataLoading(true);
    dispatch(setFilteresToOrders(filters));

    navigate('/admin-orders', { state: { selectedTabId: 1 } });
  };

  // Render personalizado para la columna de área
  const renderAreaCell = (data: any) => {
    const areaName = data.value || 'Sin nombre';
    const isSmallScreen = isXSmall || isSmall;
    const maxLength = isSmallScreen ? 15 : 25; // Límite de caracteres según pantalla
    const truncatedName = areaName.length > maxLength ? `${areaName.substring(0, maxLength)}...` : areaName;

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
        title={areaName.length > maxLength ? areaName : undefined}>
        <span
          style={{
            fontSize: '0.8rem',
            fontWeight: '500',
            color: '#495057',
            lineHeight: '1.2',
            cursor: areaName.length > maxLength ? 'help' : 'default',
          }}>
          {truncatedName}
        </span>
      </div>
    );
  };

  // Render personalizado para el botón de acción - responsive
  const renderActionCell = (data: any) => {
    const isSmallScreen = isXSmall || isSmall;
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Button text={isSmallScreen ? '' : 'Ver'} icon={isSmallScreen ? 'eyeopen' : undefined} type='default' stylingMode='contained' onClick={() => handleViewClick(data.data)} hint='Ver detalles del área' height={26} />
      </div>
    );
  };
  return (
    <CardAnalytics title='Lista de trabajo áreas' contentClass='sales' onRefreshClick={handleRefreshClick} lastUpdate={dashboard.UltimaActualizacion} isLoading={dashboard.Loading || dataLoading}>
      <DataGrid
        height='100%'
        columnAutoWidth={true}
        allowColumnResizing={false}
        dataSource={dashboard.Data}
        keyExpr='Aa_Id'
        showBorders={false}
        showRowLines={true}
        showColumnLines={false}
        rowAlternationEnabled={true}
        hoverStateEnabled={true}
        onRowPrepared={(e) => {
          if (e.rowType === 'data') {
            e.rowElement.style.transition = 'all 0.2s ease';
            e.rowElement.style.height = '32px'; // Reducir altura de filas
            e.rowElement.style.minHeight = '32px';
          }
        }}
        onCellPrepared={(e) => {
          if (e.rowType === 'data') {
            e.cellElement.style.padding = '4px 8px'; // Reducir padding de celdas
            e.cellElement.style.fontSize = '13px'; // Reducir tamaño de fuente
            e.cellElement.style.lineHeight = '1.2';
          }
        }}>
        <Scrolling mode='virtual' />

        {/* Columna Área mejorada */}
        <Column dataField='Aa_Nombre' caption='ÁREA' cellRender={renderAreaCell} allowFiltering={true} />

        {/* Columna %Validación - mantener intacta */}
        <Column
          dataField='PorcentajeValidacion'
          caption='% VALIDACIÓN'
          alignment='center'
          width={120}
          cellRender={(data) => {
            const porcentaje = data.value || 0;
            return (
              <div className='meter-container' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <meter value={porcentaje} min={0} max={100} low={1} high={99} optimum={100} className='animated-meter' style={{ width: '60px', height: '12px' }} />
                <span style={{ fontSize: '11px', fontWeight: '600', minWidth: '30px', color: porcentaje === 100 ? '#4caf50' : porcentaje === 0 ? '#f44336' : '#666' }}>{porcentaje}%</span>
              </div>
            );
          }}
        />

        {/* Columna Acciones - responsive */}
        <Column caption='ACCIONES' alignment='center' cellRender={renderActionCell} width={90} />
      </DataGrid>
    </CardAnalytics>
  );
};
